module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular.93a118ae.otf";